import { PlateEditor, Value } from '@udecode/plate-common';

import { floatingLinkSelectors } from '../hooks';
import { triggerFloatingLinkEdit } from './triggerFloatingLinkEdit';
import { triggerFloatingLinkInsert } from './triggerFloatingLinkInsert';

export const triggerFloatingLink = <V extends Value>(
  editor: PlateEditor<V>,
  {
    focused,
  }: {
    focused?: boolean;
  } = {},
): void => {
  if (floatingLinkSelectors.mode() === 'edit') {
    triggerFloatingLinkEdit(editor);
    return;
  }

  triggerFloatingLinkInsert(editor, {
    focused,
  });
};
